import { useCallback } from 'react';
import { createCreateUseModal, Flex, PrimaryButton, Typography } from '@banhala/ui-kit';
import { getScreenWidth } from '../../utils/getScreenWidth/getScreenWidth';
import { DownloadQR } from './DownloadQR';
import { ablyUserAgent, airbridge } from '@banhala/utils';
import { useRoute } from '@react-navigation/native';
import { isWeb } from '../../utils';
import { Keyboard } from 'react-native';

const createAlertModal = createCreateUseModal({
  modalProps: {
    coverScreen: isWeb,
    style: {
      margin: 0,
      padding: 0,
      justifyContent: 'center',
      alignItems: 'center',
    },
    deviceWidth: isWeb ? getScreenWidth() : undefined,
    animationIn: 'fadeIn',
    animationOut: 'fadeOut',
    backdropTransitionOutTiming: 10,
    onBackButtonPress() {
      Keyboard?.dismiss();
    },
    onBackdropPress() {
      Keyboard?.dismiss();
    },
  },
  cancelOnBackButtonPress: true,
  cancelOnBackdropPress: true,
});

export const useAppDownloadModal = createAlertModal<void, void>(
  ({ confirm }) => {
    const routes = useRoute();

    const onPressShowInApp = useCallback(() => {
      if (ablyUserAgent.isMobile) {
        const params = routes.params
          ? (Object.values(routes.params)?.[0] ?? null)
          : null;

        const link = `ably://react/App?screen=${routes.name}${params ? `&params=${params}` : ''}`;

        airbridge.openDeeplink({
          type: 'redirect',
          deeplinks: {
            ios: link,
            android: link,
          },
          fallbacks: {
            ios: 'itunes-appstore',
            android: 'google-play',
          },
        });
        return;
      }

      confirm();
    }, [confirm, routes.name, routes.params]);

    return (
      <Flex
        backgroundColor={'white'}
        width={getScreenWidth() - 64}
        borderRadius={12}
        padding={{ top: 24, bottom: 16, horizontal: 16 }}
      >
        <Flex alignItems={'center'} margin={{ bottom: 16 }}>
          <Typography type="h4" color={'content_primary'}>
            해당 기능은 앱에서 사용 가능해요!
          </Typography>
          <Typography type="body1" color={'content_secondary'}>
            앱 설치하고 더 편하게 쇼핑해보세요
          </Typography>
          <Flex
            margin={{ top: 20, bottom: 16 }}
            width={100}
            height={100}
            borderColor={'border_secondary'}
            borderWidth={1}
            borderRadius={12}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <DownloadQR></DownloadQR>
          </Flex>
          <Typography type="body2" color={'content_secondary'}>
            휴대폰으로 QR 코드를 스캔해서 설치해보세요
          </Typography>
        </Flex>

        {ablyUserAgent.isMobile ? (
          <Flex gap={8}>
            <PrimaryButton
              variant={'fill'}
              size={'medium'}
              onPress={onPressShowInApp}
            >
              앱에서 보기
            </PrimaryButton>
            <PrimaryButton
              variant={'fill'}
              size={'medium'}
              onPress={confirm}
              outline
            >
              닫기
            </PrimaryButton>
          </Flex>
        ) : (
          <PrimaryButton
            variant={'fill'}
            size={'medium'}
            onPress={confirm}
          >
            확인
          </PrimaryButton>
        )}
      </Flex>
    );
  },
);
